<sharry-header></sharry-header>
<div class="what">
  <div class="what__title">
    <h1 [innerHTML]="'what.title' | i18next"></h1>
  </div>
  <div class="what__description">
    <div class="what__description__video">
      <div
        class="embed"
        sharryVideoLoader>
        <section
          class="sharry__video-embed"
          data-source="youtube"
          data-video-url="https://www.youtube.com/embed/-Z2f4evIQZc"
          data-background-image="https://media.sharry.land/app/images/what/cover-video3.webp"></section>
      </div>
    </div>
    <div class="what__description__text">
      <p [innerHTML]="'what.description' | i18next"></p>
    </div>
  </div>
  <div class="what__do">
    <h2 [innerHTML]="'what.do-title' | i18next"></h2>
    <div>
      <div>
        <sharry-icon
          name="map-trifold"
          type="phosphor"
          svgClass="svg-icon"></sharry-icon>
        <p [innerHTML]="'what.do-1-point' | i18next"></p>
      </div>
      <div>
        <sharry-icon
          name="polygon"
          type="phosphor"
          svgClass="svg-icon"></sharry-icon>
        <p [innerHTML]="'what.do-2-point' | i18next"></p>
      </div>
      <div>
        <sharry-icon
          name="user-switch"
          type="phosphor"
          svgClass="svg-icon"></sharry-icon>
        <p [innerHTML]="'what.do-3-point' | i18next"></p>
      </div>
    </div>
  </div>
  <div class="what__spot">
    <h2 [innerHTML]="'what.spot.title' | i18next"></h2>
    <div class="what__spot__video">
      <div
        class="embed"
        sharryVideoLoader>
        <section
          class="sharry__video-embed"
          data-source="youtube"
          data-video-url="https://www.youtube.com/embed/sVLx8VU8ZGY"
          data-background-image="https://media.sharry.land/app/images/what/pictvideo-spot.webp"></section>
      </div>
    </div>
  </div>
  <div class="what__agend">
    <h2 [innerHTML]="'what.agend-title' | i18next"></h2>
    <p [innerHTML]="'what.agend-description' | i18next"></p>
    <img
      alt="obiettivi"
      src="https://media.sharry.land/app/images/what/goals.webp" />
  </div>
  <div class="what__challenge">
    <h2 [innerHTML]="'what.challenge-title' | i18next"></h2>
    <div class="what__challenge__body">
      <p [innerHTML]="'what.challenge-description' | i18next"></p>
      @if (usingCapacitor) {
        <a
          (click)="
            capacitorDownloadFile(
              'https://media.sharry.land/app/images/what/Presentazione_SharryLand.pdf',
              'Presentazione_SharryLand'
            )
          "
          ><img
            alt="image"
            src="https://media.sharry.land/app/images/what/Presentazione-SharryLand-giu-2022.webp"
            width="250"
            style="border-radius: 5px 5px 5px 5px; box-shadow: 0px 7px 14px rgba(60, 66, 87, 0.12)" />
          <p
            class="lead privacy"
            style="margin-top: 1em">
            {{ 'what.download-pdf' | i18next }}
          </p>
        </a>
      }
      @if (!usingCapacitor) {
        <a
          href="https://media.sharry.land/app/images/what/Presentazione_SharryLand.pdf"
          target="_blank"
          download="Presentazione_SharryLand.pdf"
          ><img
            alt="image"
            src="https://media.sharry.land/app/images/what/Presentazione-SharryLand-giu-2022.webp"
            width="250"
            style="border-radius: 5px 5px 5px 5px; box-shadow: 0px 7px 14px rgba(60, 66, 87, 0.12)" />
          <p
            class="lead privacy"
            style="margin-top: 1em">
            {{ 'what.download-pdf' | i18next }}
          </p>
        </a>
      }
    </div>
  </div>
  <div class="what__discover">
    <h2>{{ 'what.discover-title' | i18next }}</h2>
    <a
      target="_blank"
      mat-flat-button
      color="primary"
      class="sharry-big"
      href="https://info.sharry.land/guida/chisiamo.html"
      >{{ 'what.discover-button' | i18next }}</a
    >
  </div>
  <div class="what__press">
    <h2 [innerHTML]="'what.press-title' | i18next"></h2>
    <div class="what__press__body">
      <a
        href="https://mediasetinfinity.mediaset.it/video/eplanet/lapp-per-il-turismo-lento_F312329501005C05"
        target="_blank">
        <img
          src="https://media.sharry.land/app/images/homepage/Mediaset_Infinity_logo.webp"
          alt="logo-mediaset-infinity" />
      </a>
      <a
        href="https://info.sharry.land/it/pdf/corriere-della-sera-9-12-2023.webp"
        target="_blank">
        <img
          src="https://media.sharry.land/app/images/homepage/Corriere-della-Sera.webp"
          alt="logo-corriere-della-sera" />
      </a>
      <a
        href="https://www.repubblica.it/viaggi/2023/10/12/news/aree_interne_italiane_in_nuova_mappa_digitale-417601122/"
        target="_blank">
        <img
          src="https://media.sharry.land/app/images/homepage/La_Repubblica.webp"
          alt="logo-la-repubblica" />
      </a>
      <a
        href="https://info.sharry.land/it/pdf/29122023-QN-QNSETTIMANALI-WEEKEND.webp"
        target="_blank">
        <img
          src="https://media.sharry.land/app/images/homepage/quotidiano-nazionale-itinerari.webp"
          alt="logo-quotidiano-nazionale" />
      </a>
      <a
        href="https://www.ilsole24ore.com/art/borghi-startup-che-scommette-sull-impatto-turismo-rurale-AEczJskB?fbclid=IwAR1KsDK1-Y6X6Ds61cNqTHmTPvdzQZ_rT9xwdOp4j5-4cIIYQJbXofSH4js"
        target="_blank">
        <img
          src="https://media.sharry.land/app/images/homepage/ilsole24ore-o-2021.svg"
          alt="logo-sole-24-ore" />
      </a>
      <a
        href="https://www.wired.it/economia/start-up/2019/11/22/sharryland-weekend/"
        target="_blank">
        <img
          src="https://media.sharry.land/app/images/homepage/logo-wired.svg"
          alt="logo-wired" />
      </a>
    </div>
  </div>
</div>

<sharry-footer class="is-not-mobile"></sharry-footer>
